import Highcharts from 'highcharts';
import { PIE_BASE_COLORS } from '../../config/portfolioAllocationColors';

const base = PIE_BASE_COLORS;

const glossyColors = base.map(c => ({
  radialGradient: { cx: 0.35, cy: 0.3, r: 0.9 },
  stops: [
    [0, Highcharts.color(c).brighten(0.35).get('rgb')], // brillo
    [0.6, Highcharts.color(c).get('rgb')],
    [1, Highcharts.color(c).brighten(-0.35).get('rgb')], // sombra
  ],
}));

const pieOptions = {
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
    spacing: [10, 10, 10, 10],
  },
  plotOptions: {
    series: {
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        width: 8,
        offsetX: 0,
        offsetY: 3,
      },
    },
    pie: {
      depth: 45,
      innerSize: 0,
      distance: 10,
      allowPointSelect: true,
      dataLabels: {
        style: {
          color: 'black',
          fontWeight: 700,
          fontSize: '13px',
          textOutline: '1px contrast',
        },
        enabled: true,
        format: '{point.percentage:.1f} %',
      },
      showInLegend: true,
    },
  },
  tooltip: {
    pointFormat: '<b>{point.percentage:.1f}%</b> (Gross: {point.y:.2f}%)',
  },
  colors: glossyColors,
};
export default pieOptions;
